<div class="errors-list-container flex flex-row gap-[8px]">
  <app-active-error-tile
    *ngFor="let activeError of activeErrorList$ | async"
    [activeError]="activeError"
  >
  </app-active-error-tile>
</div>
